/* tslint:disable */
import {
  County
} from '../index';

declare var Object: any;
export interface ConstituencyInterface {
  "name": string;
  "id"?: number;
  "county_id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
  county?: County;
}

export class Constituency implements ConstituencyInterface {
  "name": string;
  "id": number;
  "county_id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  county: County;
  constructor(data?: ConstituencyInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Constituency`.
   */
  public static getModelName() {
    return "Constituency";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Constituency for dynamic purposes.
  **/
  public static factory(data: ConstituencyInterface): Constituency{
    return new Constituency(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Constituency',
      plural: 'Constituencies',
      path: 'Constituencies',
      properties: {
        "name": {
          name: 'name',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "county_id": {
          name: 'county_id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
        county: {
          name: 'county',
          type: 'County',
          model: 'County'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/theme/services/sdk/models/Constituency.ts